<template>
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      :rules="rules"
      class="login-container"
      v-loading="loading">
      <h3>系统登录</h3>
      <el-form-item label="用户名" prop="UserName">
        <el-input v-model="form.UserName" size="small"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="Password">
        <el-input type="password" v-model="form.Password" size="small"></el-input>
      </el-form-item>
      <el-form-item
        label="验证码"
        prop="Code"
        style="text-align: left;">
        <el-input v-model="form.Code" maxlength="4" size="small" style="width:50%;text-align:left;margin-right:10px; vertical-align:middle"></el-input>
        <el-image :src="VerifyCode" @click="getVerifyCode()" style="vertical-align:middle; height:32px; text-align:right;">
        </el-image>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" v-on:click="formSubmit('form')">提交</el-button>
        <el-button size="small" v-on:click="resetForm('form')">重置</el-button>
      </el-form-item>
    </el-form>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      oasApi: this.$baseUrl,
      formUrl: this.formUrl,
      VerifyCodeKey: '',
      VerifyCode: '',
      form: {
        UserName: '',
        Password: '',
        Code: ''
      },
      rules: {
        UserName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        Code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '验证码错误', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    GetToken: function () {
      var _this = this
      axios.Get(_this.oasApi + '/api/JWT/GetToken', {

      }).then(function (response) {
        localStorage.setItem('token', response.data)
      })
    },
    formSubmit: function (formref) {
      var _this = this
      _this.$refs[formref].validate((valid) => {
        if (valid) {
          _this.loading = true
          axios.post(_this.oasApi + '/api/UpTop/Login', {
            UserName: _this.form.UserName,
            Password: _this.form.Password,
            VerifyCodeKey: _this.VerifyCodeKey,
            VerifyCode: _this.form.Code
          }, {

          }).then(function (response) {
            var obj = response.data
            sessionStorage.setItem('accessToken', JSON.stringify({
              access_token: obj.access_token,
              expies_in: obj.expies_in,
              refresh_Token: obj.refresh_Token,
              createTime: new Date().getTime(),
              userID: obj.userID,
              oasToken: obj.oasToken
            }))
            _this.loading = false
            _this.$router.push({name: 'Payment'})
          }).catch(function (response) {
            if (response.response && response.response.data.Message) {
              _this.$message.error(response.response.data.Message)
            } else {
              _this.$message.error(response.message)
            }
            _this.getVerifyCode()
            _this.form.Password = ''
            _this.loading = false
          })
        } else {
          return false
        }
      })
    },
    resetForm: function (formName) {
      this.$refs[formName].resetFields()
    },
    getVerifyCode: function () {
      var _this = this
      axios.get(_this.oasApi + '/api/UpTop/GetVerifyCode', {

      }).then(function (response) {
        _this.VerifyCode = ' data:image/jpeg;base64,' + response.data.VerifyCode
        _this.VerifyCodeKey = response.data.VerifyCodeKey
      })
      _this.form.Code = ''
    }
  },
  created: function () {
    this.getVerifyCode()
  }
}
</script>
<style scoped>
  .login-container{
    width:400px;
    margin:0 auto;
    border:1px solid #ccc;
    padding: 30px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    box-shadow: 0 0 25px #909399;
    margin-top:10%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue